<template>
  <div class="indexPc">
    <!-- <img class="indexImgFixed" src="https://cdn.youjiajk.com/indexBannerPc_new.png " /> -->
    <div class="indexImgFixed">
      <el-carousel height = "621px">
        <el-carousel-item v-for="(item,index) in bannerPics" :key="index" >
          <img :class="item.jumpType === 1 ? 'img jump':'img'" :src="item.imageUrl" @click="bannerClick(item)"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="backgroundGray">
      <div class="itemGroup container">
        <div class="item" v-for="(item, index) in itemList" :key="index" @click="goPage(item.path)">
          <p class="title">{{ item.title }}</p>
          <p class="desc">{{ item.desc }}<img src="../../assets/image/indexIcon1.png" /></p>
        </div>
      </div>
    </div>
    <div class="swiper_wrapperBox">
      <div class="container">
        <div class="swiper" v-if="reRender">
          <swiper class="swiper" :options="swiperOptionh">
            <swiper-slide>
              <div class="swiperCon">
                <div class="txt">
                  <div class="title">
                    <img src="../../assets/image/indexIcon.png" alt="">
                    <span>家医优护</span>
                  </div>
                  <div class="con">
                    <p>拥有
                      <countTo class="num" :startVal="startVal" :endVal="endVal4" :duration="2000" separator="">
                      </countTo><span class="num">+</span>
                      位自有及签约医护伙伴
                    </p>
                    <p>覆盖全国
                      <countTo class="num" :startVal="startVal" :endVal="endVal5" :duration="1500" separator="">
                      </countTo><span class="num">+</span>
                      座城市
                    </p>
                    <p>
                      <span class="num">7*24</span>
                      小时管家式守护
                    </p>
                  </div>
                </div>
                <img class="swiperSliderImg" src="https://cdn.youjiajk.com/swiperBanner1.png" alt="">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiperCon">
                <div class="txt">
                  <div class="title">
                    <img src="../../assets/image/indexIcon.png" alt="">
                    <span>优选医疗网络</span>
                  </div>
                  <div class="con">
                    <p>系统链接
                      <countTo class="num" :startVal="startVal" :endVal="endVal7" :duration="2000" separator="">
                      </countTo><span class="num">+</span>
                      家体检机构、
                    </p>
                    <p>
                      <countTo class="num" :startVal="startVal" :endVal="endVal8" :duration="2000" separator="">
                      </countTo><span class="num">+</span>
                      家眼科机构、
                      <countTo class="num" :startVal="startVal" :endVal="endVal9" :duration="2000" separator="">
                      </countTo><span class="num">+</span>
                      家齿科机构
                    </p>
                    <p>近
                      <countTo class="num" :startVal="startVal" :endVal="endVal10" :duration="2000" separator="">
                      </countTo><span class="num">+</span>
                      家中医诊所
                    </p>
                  </div>
                </div>
                <img class="swiperSliderImg" src="https://cdn.youjiajk.com/swiperBanner3.png" alt="">
              </div>
            </swiper-slide>
            <div class="swiper-pagination swiper-pagination-h" slot="pagination"></div>
          </swiper>
          <div class="swiper-button-next swiper_btn"></div>
          <div class="swiper-button-prev swiper_btn"></div>
        </div>
      </div>

    </div>

    <div class="work" ref="work">
      <div class="container">
        <div class="title">服务客户</div>
        <div class="imgList">
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal1" :duration="1500" separator=""></countTo>
              <span>+</span>
            </div>
            <p>保司及企业客户</p>
          </div>
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal2" :duration="2000" separator=""></countTo>
              万<span>+</span>
            </div>
            <p>付费终端用户</p>
          </div>
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal3" :duration="1800"></countTo>万<span>+</span>
            </div>
            <p>累计服务人数</p>
          </div>
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal11" :duration="1800"></countTo>万<span>+</span>
            </div>
            <p>累计服务人次</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 公司文化 -->
    <div class="company-culture">
      <div class="container">
        <div class="cultureCon">
          <div class="item">
            <div class="itemPosition">
              <img class="icon" src="../../assets/image/icon1.png" />
              <p class="itemTitle">使命</p>
              <p class="itemTxt">让每个家庭拥有自己的医护朋友</p>
            </div>
            <img class="num" src="../../assets/image/01Icon.png" />

          </div>
          <div class="item">
            <div class="itemPosition">
              <img class="icon" src="../../assets/image/icon1.png" />
              <p class="itemTitle">愿景</p>
              <p class="itemTxt">中国领先的数字化管理式医疗健康服务组织</p>
            </div>
            <img class="num" src="../../assets/image/02Icon.png" />
          </div>
          <div class="item">
            <div class="itemPosition">
              <img class="icon" src="../../assets/image/icon1.png" />
              <p class="itemTitle">价值观</p>
              <p class="itemTxt">用户至上 合作共赢 专业价值 追求卓越</p>
            </div>
            <img class="num" src="../../assets/image/03Icon.png" />
          </div>
        </div>
      </div>
    </div>


    <!-- 合作伙伴 -->
    <div class="cooperation backgroundGray">
      <div class="container">
        <div class="title">
          <p>合作伙伴</p>
          <p class="subTitle"><span @click="logoIndex = 1">保司+渠道</span> | <span @click="logoIndex = 2">医疗网络</span></p>
        </div>
        <div class="content">
          <div class="optionLeft"></div>
          <div class="optionRight"></div>
          <template v-if="logoIndex == 1">
            <vue-seamless-scroll :data="cooperationList" :class-option="optionLeft" class="seamless-warp1">
              <ul class="item">
                <!-- <li v-for="(item,index) in cooperationList" :key="index">
                  <img :src="item.imgUrl" width="224" height="112" />
                </li> -->
                <li>
                  <img src="../../assets/image/cooperation/1@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/2@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/3@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/4@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/5@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/6@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/7@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/8@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/9@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/10@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/11@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/12@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/13@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/14@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/15@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/16@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/17@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/35@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/38@2x.png" />
                </li>
              </ul>
            </vue-seamless-scroll>
            <vue-seamless-scroll :data="cooperationList1" :class-option="optionLeft1" class="seamless-warp1"
              v-if="isScroll">
              <ul class="item">
                <!-- <li v-for="(item,index) in cooperationList1" :key="index">
                  <img :src="item.imgUrl" width="224" height="112" />
                </li> -->
                <li>
                  <img src="../../assets/image/cooperation/18@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/19@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/20@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/21@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/22@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/23@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/24@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/25@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/26@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/27@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/28@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/29@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/30@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/31@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/32@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/33@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/34@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/36@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/37@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/39@2x.png" />
                </li>
              </ul>
            </vue-seamless-scroll>
          </template>
          <template v-if="logoIndex == 2">
            <vue-seamless-scroll :data="cooperationList4" :class-option="optionLeft2" class="seamless-warp2">
              <ul class="item">
                <li>
                  <img src="../../assets/image/cooperation/gys_1@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_2@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_3@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_4@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_5@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_6@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_7@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_8@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_9@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_10@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_11@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_12@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_26@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_28@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_30@2x.png" />
                </li>
              </ul>
            </vue-seamless-scroll>
            <vue-seamless-scroll :data="cooperationList5" :class-option="optionLeft2" class="seamless-warp2"
              v-if="isScroll">
              <ul class="item">
                <li>
                  <img src="../../assets/image/cooperation/gys_13@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_14@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_15@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_16@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_17@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_18@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_19@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_20@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_21@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_22@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_23@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_24@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_25@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_27@2x.png" />
                </li>
                <li>
                  <img src="../../assets/image/cooperation/gys_29@2x.png" />
                </li>
              </ul>
            </vue-seamless-scroll>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
import vueSeamlessScroll from 'vue-seamless-scroll'
import countTo from 'vue-count-to'

let vm = null
export default {
  props:['configurationData','bannerPics'],
  data () {
    return {
      itemList: [{
        title: '商业保险创建解决方案',
        iconUrl: require('../../assets/image/item1.png'),
        coverIcon: require('../../assets/image/item11.png'),
        desc: '助力保费规模增长可持续',
        path: 'insurancePlan'
      },
      {
        title: '医疗行业解决方案',
        iconUrl: require('../../assets/image/item2.png'),
        coverIcon: require('../../assets/image/item22.png'),
        desc: '助力用户全周期疾病管理',
        path: 'insurancePlan'
      },
      {
        title: '健康企业一站式解决方案',
        iconUrl: require('../../assets/image/item3.png'),
        coverIcon: require('../../assets/image/item33.png'),
        desc: '助力员工健康风险可预防',
        path: 'insurancePlan'
      }
      ],
      hoverItem: false,
      swiperOptionh: {
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination-h',
          clickable: true,
          renderBullet: function (index, className) {
            let imgUrl;
            let txt;
            if (index == 0) {
              imgUrl = "https://cdn.youjiajk.com/swiperIcon1.png"
              txt = '家医优护'
            } 
            // else if (index == 1) {
            //   imgUrl = 'https://cdn.youjiajk.com/swiperIcon2.png'
            //   txt = '药品福利管理'
            // } 
            else if (index == 1) {
              imgUrl = 'https://cdn.youjiajk.com/swiperIcon3.png'
              txt = '优选医疗网络'
            }
            return '<p class="' + className + '">' + '<img src=" ' + imgUrl + '" />' + '<span>' + txt +
              '</span></p>'
          }
        },
        loop: false,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChange () {
            vm.swiperCurrentIndex = this.activeIndex
          }
        }
      },
      reRender: false,
      startVal: 0,
      endVal1: 0,
      endVal2: 0,
      endVal3: 0,
      endVal4: 0,
      endVal5: 0,
      endVal6: 0,
      endVal7: 0,
      endVal8: 0,
      endVal9: 0,
      endVal10: 0,
      endVal11: 0,
      endVal12: 0,
      cooperationList: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation1_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation2_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation3_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation4_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation5_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation6_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation7_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation8_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation9_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation12_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation15_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation18.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation21.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation24.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation27.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation32.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation33.png'
      }
      ],
      cooperationList1: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation34.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation35.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation36.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation37.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation38.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation39.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation42.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation45.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation48.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation51.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation52.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation53.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation54.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation55.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation56.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation57.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation58.png'
      }
      ],
      cooperationList4: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation10_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation11_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation13_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation14_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation16.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation17.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation19.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation20.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation22.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation23.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation25.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation26.png'
      }],
      cooperationList5: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation28.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation29.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation30.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation31.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation40.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation41.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation43.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation44.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation46.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation47.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation49.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation50.png'
      },],
      swiperOption1: {
        direction: 'vertically',
        speed: 1000,
        autoplay: {
          delay: 1,
          autoplayDisableOnInteraction: false
        },
        loop: true,
        spaceBetween: 0,
        slidesPerview: 8,
        allowTouchMove: false
      },
      swiperCurrentIndex: 0,
      isScroll: false,
      logoIndex: 1
    }

  },
  components: {
    swiper,
    swiperSlide,
    vueSeamlessScroll,
    countTo,
  },
  created () {
    vm = this
    setTimeout(() => {
      this.reRender = true
    }, 100)
    setTimeout(() => {
      this.endVal4 = Number(this.configurationData[0].dvalue)
      this.endVal5 = Number(this.configurationData[1].dvalue)
      this.endVal6 = 40000
      this.endVal7 = Number(this.configurationData[2].dvalue)
      this.endVal8 = Number(this.configurationData[3].dvalue)
      this.endVal9 = Number(this.configurationData[4].dvalue)
      this.endVal10 = Number(this.configurationData[5].dvalue)
      this.endVal12 = 20
    }, 1000)
    setTimeout(() => {
      this.isScroll = true
    }, 1000)

  },
  computed: {
    optionLeft () {
      return {
        direction: 2,
        limitMoveNum: 17,
      }
    },
    optionLeft1 () {
      return {
        direction: 2,
        limitMoveNum: 17,
      }
    },
    optionLeft2 () {
      return {
        direction: 2,
        limitMoveNum: 12,
      }
    },
    optionLeft3 () {
      return {
        direction: 2,
        limitMoveNum: 12,
      }
    }
  },
  watch: {
    swiperCurrentIndex (val) {
      if (val == 0) {
        this.endVal4 = 0
        this.endVal5 = 0
        setTimeout(() => {
          this.endVal4 = Number(this.configurationData[0].dvalue)
          this.endVal5 = Number(this.configurationData[1].dvalue)
        }, 0)
      }
      if (val == 1) {
        this.endVal6 = 0
        this.endVal12 = 0
        setTimeout(() => {
          this.endVal6 = 40000
          this.endVal12 = 20
        }, 0)
      }
      if (val == 2) {
        this.endVal7 = 0
        this.endVal8 = 0
        this.endVal9 = 0
        this.endVal10 = 0
        setTimeout(() => {
          this.endVal7 = Number(this.configurationData[2].dvalue)
          this.endVal8 = Number(this.configurationData[3].dvalue)
          this.endVal9 = Number(this.configurationData[4].dvalue)
          this.endVal10 = Number(this.configurationData[5].dvalue)
        }, 0)
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrolling)
  },
  methods: {
    addActive ($event) {
      $event.currentTarget.className = 'item coverItem'
    },
    removeActive ($event) {
      $event.currentTarget.className = 'item'
    },
    goPage (name) {
      this.$router.push({
        name: name
      })
    },
    bannerClick(item) {
      if (item.jumpType == 1 && item.jumpUrl.length > 0) {
        window.location.href = item.jumpUrl;
      }
    },
    scrolling () {
      let top1 = document.body.scrollTop || document.documentElement.scrollTop //获取滚动条位置 
      let top2 = this.$refs.work.getBoundingClientRect().top
      // if(top1 > 520) {
      //   this.$refs.headBox.background = '#FFFFFF'
      // } else {
      //   this.$refs.headBox.background = 'none'
      // }
      if (top2 <= 680) {
        this.endVal1 = Number(this.configurationData[6].dvalue)
        this.endVal2 = parseInt(this.configurationData[7].dvalue)
        this.endVal3 = parseInt(this.configurationData[8].dvalue)
        this.endVal11 = parseInt(this.configurationData[9].dvalue)
      }

    }
  }
}
</script>



<style lang="less" scoped>
.backgroundGray {
  background: #F8F9FD;
}

.backgroundWhite {
  background: #FFFFFF;
}

.indexPc {
  display: flex;
  flex-direction: column;
}

.swiper_wrapperBox {
  width: 100%;
  height: 697px;
  background-image: url("../../assets/image/indexBanner2.png");
  background-size: 100% 100%;

  .swiper {
    width: 100%;
    position: relative;

    .swiper_btn {
      width: 60px;
      height: 60px;
    }

    /deep/ .swiper-button-prev {
      background-image: url("../../assets/image/swiperArrowLeft.png");
      background-size: 100% 100%;

    }

    /deep/ .swiper-button-next {
      background-image: url("../../assets/image/swiperArrowRight.png");
      background-size: 100% 100%;
    }

    /deep/.swiper-container {
      width: 100%;

      .swiper-slide {
        width: 100%;
        // height: 800px;
        // padding-bottom: 28.1%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;

        .slider1 {
          background-image: url('https://cdn.youjiajk.com/%E5%AE%98%E7%BD%91-banner1_1.png');
          display: block;
          width: 100%;
          height: 800px;
          background-size: 1920px 800px;
          background-position: center;
          background-clip: content-box;
        }

        .slider2 {
          background-image: url('https://cdn.youjiajk.com/%E5%AE%98%E7%BD%91-banner2.jpg');
          display: block;
          width: 100%;
          height: 800px;
          background-size: 1920px 800px;
          background-position: center;
          background-clip: content-box;
        }
      }

      .swiper-pagination-bullets {
        top: 0;
        display: flex;
        justify-content: center;
        margin-top: 140px;
        border-bottom: 1px solid #e9ebed;
        height: 93px;
      }



      .swiper-pagination {
        .swiper-pagination-bullet {
          width: 72px !important;
          height: 92px !important;
          display: inline-block;
          border-radius: 4px;
          background: none;
          opacity: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 18px;
          margin: 0 100px;

          &:nth-child(2) {
            // margin: 0 262px;
            width: 108px !important;
          }

          &:nth-child(3) {
            width: 110px !important;
          }
        }

        img {
          width: 42px;
          height: 40px;
          margin-bottom: 13.5px;
        }

        .swiper-pagination-bullet-active {
          background-color: none;
          width: 72px;
          opacity: 1;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            width: 56px;
            border-bottom: 3px solid #FD8246;
            bottom: -2px;
          }
        }
      }

      .swiperCon {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 277px 144px 0;


        .txt {
          font-family: Source Han Sans CN, Source Han Sans CN-6;
          margin-top: 33px;

          .title {
            font-size: 30px;
            font-weight: 400;
            text-align: left;
            color: #333333;
            line-height: 45px;
            margin-bottom: 22px;
            display: flex;
            align-items: flex-start;

            img {
              width: 20px;
              height: 15px;
              margin: 15px 14px 0 0;
              display: inline-block;
            }
          }

          .con {
            p {
              font-size: 16px;
              font-weight: 400;
              text-align: left;
              color: #000000;
              line-height: 40px;
              margin-bottom: 19px;

              .num {
                font-size: 36px;
                font-weight: 700;
                color: #FC8046;
                font-family: DIN Alternate, DIN Alternate-9;
              }
            }
          }
        }



        .swiperSliderImg {
          width: 460px;
          height: 280px;
        }

      }
    }

    .swiper_btn {
      position: absolute;
      top: 387px;
    }
  }
}

.itemGroup {
  padding: 80px 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-content: center;

  .item {
    width: 384px;
    height: 130px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    line-height: 24px;
    font-weight: 500;
    cursor: pointer;
    border: 2px solid #ffffff;
    border-radius: 8px;
    background: linear-gradient(241deg, #ebf5f8 10%, #f3f1fa 26%, #f8f9fb 57%, #ffffff 89%);

    &:nth-child(2) {

      margin: 0 24px;
    }

    &:first-child {
      .arrow {
        margin-top: 17px;
      }
    }

    .iconImg {
      width: 64px;
      height: 64px;
      margin-bottom: 32px;
      box-shadow: 0px 4px 18px rgb(253 130 70 / 50%);
      border-radius: 22px;
    }

    .default {
      display: inline-block;
    }

    .cover {
      display: none;
    }

    .title {
      color: #333333;
      margin: 0 0 10px;
      font-size: 20px;
      line-height: 30px;
      font-weight: 400;
    }

    .desc {
      font-size: 16px;
      font-weight: 300;
      color: #666666;
      line-height: 28px;
      margin: 0;
      text-align: center;
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        margin-left: 6px;
      }
    }

    .arrow {
      width: 52px;
      height: 40px;
      margin-top: 45px;
    }
  }

  .coverItem {
    background-color: #FD8246;
    color: #FFFFFF;

    .title {
      color: #FFFFFF;
    }

    .desc {
      color: #FFFFFF;
    }

    .default {
      display: none;
    }

    .cover {
      display: inline-block;
    }
  }
}


.work {
  background: url('../../assets/image/indexBanner3.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 420px;

  .container {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    color: #000000;

    .title {
      font-size: 40px;
      font-weight: 400;
      margin-bottom: 30px;
    }

    .imgList {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      >div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        color: #FC8046;
        font-size: 36px;

        .num {
          font-weight: 700;
          margin-bottom: 14px;
        }

        span {
          font-size: 30px;
          font-weight: normal;
        }

        p {
          font-size: 16px;
          color: #666666;
          margin-top: 14px;
        }
      }
    }
  }
}

.company-culture {
  background: #FFFFFF;

  .cultureCon {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 140px 0;

    .item {
      width: 33%;
      position: relative;

      &:nth-child(1) {
        width: 30%;

        .num {
          right: 57px;
        }
      }

      &:nth-child(2) {
        width: 36%;

        .num {
          right: 35px;
        }
      }

      &:nth-child(3) {
        .num {
          right: 35px;
        }
      }

      .itemPosition {
        position: relative;
        z-index: 20;

        .icon {
          width: 36px;
          height: 54px;
        }

        .itemTitle {
          font-size: 32px;
          color: #333333;
          line-height: 39px;
          font-weight: 500;
        }

        .itemTxt {
          margin-top: 20px;
          font-size: 20px;
          font-weight: 300;
          color: #333333;
        }
      }

      .num {
        position: absolute;
        width: 134px;
        height: 182px;
        right: 44px;
        bottom: -5px;
      }
    }
  }
}

.cooperation {
  padding-bottom: 140px;
  background: rgba(248, 249, 253, 0.5);

  .container {
    overflow: hidden;
    position: relative;
  }

  .optionLeft {
    position: absolute;
    width: 372px;
    height: 342px;
    left: -40px;
    bottom: -57px;
    background-image: url('../../assets/image/optionRight.png');
    background-size: 100% 100%;
    z-index: 99;
  }

  .optionRight {
    position: absolute;
    width: 372px;
    height: 342px;
    right: -40px;
    bottom: -57px;
    background-image: url('../../assets/image/optionLeft.png');
    background-size: 100% 100%;
    z-index: 99;
  }

  .title {
    font-size: 40px;
    font-weight: 400;
    color: #333333;
    line-height: 56px;
    margin-bottom: 40px;
    margin-top: 140px;
    text-align: center;

    .subTitle {
      font-size: 16px;
      color: #666666;
      line-height: 24px;
      font-weight: 400;

      span {
        cursor: pointer;
      }

      span {
        &:hover {
          color: #FD8246;
        }
      }
    }
  }


  .item {
    font-size: 14px;
  }

  /deep/ .swiper-wrapper {
    transition-timing-function: linear !important;
  }
}

.indexImgFixed {
  width: 100%;
  // margin-top: -88px;
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .jump {
    cursor: pointer;
  }
}

.seamless-warp1 {
  overflow: hidden;
  height: 119px;
  width: 1200px;

  ul.item {
    width: 4100px;

    li {
      float: left;
      list-style-type: none;
      margin-right: 30px;
      margin-bottom: 60px;

      img {
        width: 184px;
        height: 72px;
        box-shadow: 0 4px 12px rgb(0 0 0 / 4%), 0 8px 28px rgb(0 0 0 / 6%), 0 12px 48px rgb(0 0 0 / 4%);
        border-radius: 10px;
      }
    }
  }
}

.seamless-warp2 {
  overflow: hidden;
  height: 119px;
  width: 1200px;

  ul.item {
    width: 3230px;

    li {
      float: left;
      list-style-type: none;
      margin-right: 30px;
      margin-bottom: 60px;

      img {
        width: 184px;
        height: 72px;
        box-shadow: 0 4px 12px rgb(0 0 0 / 4%), 0 8px 28px rgb(0 0 0 / 6%), 0 12px 48px rgb(0 0 0 / 4%);
        border-radius: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/indexPc.vue